module.exports = __webpack_public_path__ + "static/media/info-white-1.2bbcfa20.svg";